
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import Qrcode from '@xt/www/components/showQrcode/index.vue'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import { EnumAgreementType } from '@xt/client/enums/home/index'

@Component({
  components: {
    Qrcode,
    LazyImg
  }
})
export default class extends Vue {
  @Prop() dataSource

  get EnumAgreementType() {
    return EnumAgreementType
  }

  handleToBook() {
    window.open('/books?file=book-02')
  }

  classroom() {
    window.open('/about-xuantong')
  }

  wenfang() {
    window.open('/stationery')
  }

  icp() {
    window.open('https://beian.miit.gov.cn/')
  }

  publics() {
    window.open('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502044839')
  }

  protocol(type) {
    let jumpStr = ''
    if (type === EnumAgreementType.USER) {
      jumpStr = '/protocol/service'
    } else if (type === EnumAgreementType.PROVACY) {
      jumpStr = '/protocol/privacy'
    } else if (type === EnumAgreementType.Contact) {
      jumpStr = '/protocol/contact'
    } else if (type === EnumAgreementType.Feedback) {
      jumpStr = '/protocol/feedback'
    }
    window.open(jumpStr)
  }
  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
